import { API_endpoints } from "../config";

export const getallBookingsList = async ( status?: string[],is_forward =false): Promise<any> => {
    try {
        const body =  { 
            start_date: new Date(new Date().setFullYear(new Date().getFullYear() - 5)),
            today_date: new Date(),
            status,
            is_forward,

         } ;

        const response = await fetch(API_endpoints.getallBookingsList, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            credentials: 'include',
            body: JSON.stringify(body),
        });
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Laden von kids booking Daten.");
        }
    

        return await response.json();

        
    } catch (error) {
        console.error("Fehler beim Laden von booking Daten:", error);
    }
};
